export default __webpack_public_path__ + "static/media/dual_Splitter.571ce462.png";